import { SvgIcon, SvgIconProps } from '@material-ui/core';

export const CopyIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 12 11"  fill="none" >
      <path d="M2.25 7H1.75C1.48478 7 1.23043 6.89464 1.04289 6.70711C0.855357 6.51957 0.75 6.26522 0.75 6V1.5C0.75 1.23478 0.855357 0.98043 1.04289 0.792893C1.23043 0.605357 1.48478 0.5 1.75 0.5H6.25C6.51522 0.5 6.76957 0.605357 6.95711 0.792893C7.14464 0.98043 7.25 1.23478 7.25 1.5V2M5.25 4H9.75C10.3023 4 10.75 4.44772 10.75 5V9.5C10.75 10.0523 10.3023 10.5 9.75 10.5H5.25C4.69772 10.5 4.25 10.0523 4.25 9.5V5C4.25 4.44772 4.69772 4 5.25 4Z" stroke="black"  fill="none"  strokeLinecap="round" strokeLinejoin="round"/>
    </SvgIcon>

  );
};
